export default {
  props: {
    useBackgroundColor: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: '#000',
    },
    backgroundImage: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    sectionStyle() {
      const styles = {};
      if (this.backgroundImage) {
        styles.backgroundImage = `url(${this.backgroundImage})`;
      }

      if (this.backgroundColor && this.useBackgroundColor) {
        styles.backgroundColor = this.backgroundColor;
      }
      return styles;
    },
  },
};
